import { jsx } from "react/jsx-runtime";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import { validateTidalLicense } from "../../base/index.js";
function InsertInvitation(props) {
  return /* @__PURE__ */ jsx(
    InsertInvitationIcon,
    {
      "data-testid": "InsertInvitation",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "InsertInvitation",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
InsertInvitation.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "InsertInvitation"
};
validateTidalLicense();
export {
  InsertInvitation
};
//# sourceMappingURL=InsertInvitation.js.map
